import { render, staticRenderFns } from "./DummyLibraryItem.vue?vue&type=template&id=a5f7ddde"
import script from "./DummyLibraryItem.vue?vue&type=script&lang=js"
export * from "./DummyLibraryItem.vue?vue&type=script&lang=js"
import style0 from "./DummyLibraryItem.vue?vue&type=style&index=0&id=a5f7ddde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports